export default "__VITE_ASSET__a3f41a68__"